"use client";

import { Toaster as Sonner } from 'sonner';

export function Toaster() {
  return (
    <Sonner
      className="toaster group"
      position="top-right"
      richColors
    />
  );
}
